import React from 'react';

const ScrollingBanner = () => {
  const text = "Welcome to Life Care and Wellness";
  const repeatedText = Array(8).fill(text).join(" • ");

  return (
    <div 
      className="relative overflow-hidden py-4"
      style={{ backgroundColor: '#6c9c48' }}
    >
      <div className="scroll-container">
        <div className="scroll-text">
          <span className="text-xl md:text-2xl font-semibold text-white whitespace-nowrap">
            {repeatedText}
          </span>
        </div>
        <div className="scroll-text" aria-hidden="true">
          <span className="text-xl md:text-2xl font-semibold text-white whitespace-nowrap">
            {repeatedText}
          </span>
        </div>
      </div>

      <style jsx>{`
        .scroll-container {
          display: flex;
          white-space: nowrap;
        }
        
        .scroll-text {
          display: inline-block;
          animation: scroll 40s linear infinite;
        }
        
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .scroll-container:hover .scroll-text {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default ScrollingBanner;
